module.exports = __webpack_public_path__ + "img/whatsapp.4d398d6e.svg";